import React from 'react';
import { ChartBar20 } from '@carbon/icons-react';

import type { Product } from '#config/products';
import LegacyAppLayout from '#coreComponents/LegacyAppLayout';
import type Products from '.';
import SupportMessageInProduct from '#coreComponents/SupportMessageInProduct/SupportMessageInProduct';

const productPage = (productName: keyof typeof Products) => async () => {
  // this cannot be a param, dont try to make this function generic
  const products = (await import('.')).default;
  return {
    default: products[productName],
  };
};

const Overview = React.lazy(productPage('Overview'));
const Metrics = React.lazy(productPage('Metrics'));
const BenchmarkInstitutions = React.lazy(productPage('BenchmarkInstitutions'));
const PeerGroupAnalysis = React.lazy(productPage('PeerGroupAnalysis'));
const ExecutiveSummary = React.lazy(productPage('ExecutiveSummary'));

const dataplusLatamConfig: Product = {
  name: 'DataPlus Latam',
  authKey: 'dataplusLatam',
  description:
    'Based on THE’s WUR data, access the full dataset behind THE’s Latin America Rankings',
  path: 'latam',
  icon: ChartBar20,
  color: 'redOrange',
  usesLegacyPermissions: true,
  featureFlagId: 'datapluslatam',
  disabledFeatureComponent: () => (
    <SupportMessageInProduct productName="Data+ LatAm Dashboard" />
  ),
  productConfig: {
    topbar: {
      title: 'DataPLus Latam',
      titleAcronym: 'LATAM',
      rank: '1',
      filter: {
        hasPeerSelector: true,
        hasQueryBuilder: false,
      },
    },
  },
  pages: [
    {
      name: 'Overview',
      path: 'overview',
      component: Overview,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'Metrics',
      path: 'metrics',
      component: Metrics,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'Benchmark Institutions',
      path: 'benchmark-institutions',
      component: BenchmarkInstitutions,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'Peer Group Analysis',
      path: 'peer-group-analysis',
      component: PeerGroupAnalysis,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'Executive Summary',
      path: 'executive-summary',
      component: ExecutiveSummary,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
  ],
};

export default dataplusLatamConfig;
